import { getI18n } from 'react-i18next';

import Config from '../../../../Config';
import Logger from '../../../../lib/Logger';
import Events from '../../../../lib/EventEmitter';

import LearningLayout from './containers/LearningLayoutContainer';
import LearningScreen from './containers/LearningScreenContainer';
import LearningModuleStepsScreen from './containers/LearningModuleStepsScreenContainer';
import LearningModuleStepView from './containers/LearningModuleStepViewContainer';

const register = () => {
  Logger.log('debug', `learnings.register()`);

  if (Config.getIn(['MODULE_TOGGLES', 'learnings', 'routes'])) {
    Events.dispatch(
      'ADD_MAIN_ROUTES',
      // screen name (key): [route type (element), path (prop), exact (prop), component (prop), route name]
      {
        LearningLayout: [
          'PrivateRoute',
          '/care-guide/:id([\\w\\-]+)/learnings',
          false,
          LearningLayout,
          getI18n().t('learnings_route_main'),
        ],
      }
    );

    Events.dispatch(
      'ADD_LEARNING_ROUTES',
      // screen name (key): [route type (element), path (prop), exact (prop), component (prop), route name]
      {
        LearningScreen: [
          'PrivateRoute',
          '/care-guide/:id([\\w\\-]+)/learnings/screen',
          false,
          LearningScreen,
          getI18n().t('learnings_route_main'),
        ],
        LearningModuleStepsScreen: [
          'PrivateRoute',
          '/care-guide/:id([\\w\\-]+)/learnings/module/:moduleId([\\w\\-]+)?',
          true,
          LearningModuleStepsScreen,
          getI18n().t('learnings_route_main'),
        ],
        LearningModuleStepView: [
          'PrivateRoute',
          '/care-guide/:id([\\w\\-]+)/learnings/module/:moduleId([\\w\\-]+)/step/:moduleStepId([\\w\\-]+)?',
          true,
          LearningModuleStepView,
          getI18n().t('learnings_route_main'),
        ],
      }
    );
  }
};

export default register;

Logger.log('silly', `learnings.register() loaded.`);
